import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppStates } from '../Context/appContext';
import { Navbar } from '../Components';

function ProtectRoute({ children }) {
  const navigate = useNavigate();
  const { user, setShowLoginPopup } = AppStates();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  function checkUserToken() {
    const session = localStorage.getItem('session');

    if (!session || session == 'undefined') {
      setIsLoggedIn(false);
      navigate('/');
      setShowLoginPopup(true);
      return;
    }
    setIsLoggedIn(true);
  }

  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn, user]);

  return <>{isLoggedIn ? children : <Navbar />}</>;
}

export { ProtectRoute };
